import * as React from "react";
import { IconProps } from "./IconProps";

export const IconException = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_14159_31447)">
          <path
            d="M15.4126 13.3333L9.18122 1.4333C8.83922 0.781299 8.03389 0.529299 7.38122 0.871299C7.14122 0.997299 6.94522 1.1933 6.81922 1.4333L0.587223 13.3333C0.245223 13.9853 0.497223 14.7913 1.14989 15.1333C1.34056 15.2333 1.55322 15.2853 1.76856 15.2853H14.2312C14.9679 15.2853 15.5646 14.6886 15.5646 13.952C15.5646 13.7366 15.5126 13.524 15.4126 13.3333ZM7.33322 5.6153C7.33322 5.2473 7.63189 4.94863 7.99989 4.94863C8.36789 4.94863 8.66656 5.2473 8.66656 5.6153V9.6153C8.66656 9.9833 8.36789 10.282 7.99989 10.282C7.63189 10.282 7.33322 9.9833 7.33322 9.6153V5.6153ZM8.03322 13.2886H8.01456C7.46856 13.2866 7.02056 12.8546 6.99989 12.3086C6.97989 11.7653 7.40389 11.3093 7.94722 11.2893C7.95322 11.2893 7.95922 11.2886 7.96522 11.2886H7.98389C8.52989 11.2893 8.97856 11.7206 8.99989 12.2666C9.02122 12.8093 8.59856 13.2666 8.05589 13.288C8.04856 13.288 8.04056 13.2886 8.03322 13.2886Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_14159_31447">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
